import React, { useState, useEffect } from 'react';
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { uploadImageCDN } from '../utils/utility';

const UploadButton = React.forwardRef((props, ref) => {
  const { onChange, value, name } = props;
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    // Sync internal fileList with external value from Form
    // When value is empty/undefined, ensure we clear the list to avoid leaking previous state
    if (value && String(value).trim()) {
      setFileList([
        {
          uid: String(name || 'image'),
          name,
          url: value,
        },
      ]);
    } else {
      setFileList([]);
    }
  }, [value, name]);

  const customRequest = async (options) => {
    if (options.file) {
      options.onProgress({ percent: 0 });
      const url = await uploadImageCDN(options.file, () => {}, 'online_store');
      options.onProgress({ percent: 100 });
      options.onSuccess();
      if (onChange) onChange(url);
    }
  };

  const onRemove = () => {
    onChange('');
  };

  const onUploadChange = (info) => {
    setFileList([...info.fileList]);
  };

  return (
    <Upload
      listType="picture-card"
      customRequest={customRequest}
      onRemove={onRemove}
      ref={ref}
      accept='image/*'
      fileList={fileList}
      onChange={onUploadChange}
    >
      {fileList?.length < 1 && (
        <Button type="text" className="hover:bg-transparent">
          <UploadOutlined /> Tải file
        </Button>
      )}
    </Upload>
  );
});

export default UploadButton;
